import { ChangeDetectionStrategy, Component, Inject, OnDestroy, ViewEncapsulation } from '@angular/core'
import { MAT_DIALOG_DATA } from '@angular/material/dialog'
import { GbDashboardDialogService } from '@galabid/gb-dashboard/shared/utils'
import { TranslateService } from '@ngx-translate/core'
import * as TeamsActions from 'libs/gb-dashboard/team/data-access/src/lib/+state/teams.actions'
import { TeamModeEnum, TeamsEntity, TeamsFacade } from 'gb-dashboard-data-access-team'

@Component({
  selector: 'gb-team-profiles-dialog',
  templateUrl: './gb-team-profiles-dialog.component.html',
  styleUrl: './gb-team-profiles-dialog.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
  standalone: false,
})
export class GbTeamProfilesDialogComponent implements OnDestroy {
  editCreateLoaded$ = this.teamsFacade.editCreateLoaded$
  selectedTeam$ = this.teamsFacade.selectedTeam$
  selectedProfilesCount = 0
  selectedProfiles: string[] = []

  get mode(): TeamModeEnum {
    return this.data.mode
  }

  get isAddMode(): boolean {
    return this.mode === TeamModeEnum.Add
  }

  get isViewMode(): boolean {
    return this.mode === TeamModeEnum.View
  }

  get title(): string {
    return {
      [TeamModeEnum.Add]: 'TEAMS.EDIT.ADD_GUESTS',
      [TeamModeEnum.View]: 'TEAMS.EDIT.VIEW_GUESTS',
    }[this.mode]
  }

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: { mode: TeamModeEnum },
    private teamsFacade: TeamsFacade,
    private gbDashboardDialogService: GbDashboardDialogService,
    private translateService: TranslateService,
  ) {}

  ngOnDestroy(): void {
    this.teamsFacade.dispatch(TeamsActions.clearSelectedTeam())
  }

  onSelectedProfilesChanged(selectedProfiles: string[]): void {
    this.selectedProfiles = selectedProfiles
    this.selectedProfilesCount = selectedProfiles.length
  }

  submit(): void {
    const payload = { profiles: this.selectedProfiles }
    this.isViewMode
      ? this.teamsFacade.dispatch(TeamsActions.removeProfiles(payload))
      : this.teamsFacade.dispatch(TeamsActions.assignProfiles(payload))
  }

  showConfirmation(team: TeamsEntity): void {
    this.gbDashboardDialogService
      .openConfirmDialog({
        title: 'TEAMS.EDIT.REMOVE_CONFIRM_TITLE',
        body: this.translateService.instant('TEAMS.EDIT.REMOVE_CONFIRM_BODY', {
          team: team.name,
          count: this.selectedProfilesCount,
        }),
      })
      .subscribe((res) => {
        if (res) this.submit()
      })
  }
}
